import { Dispatch } from '@reduxjs/toolkit'
import mapboxgl from 'mapbox-gl'
import { COUNTY_ZOOM_LEVEL, stateToRegionByName, ZOOM_LEVELS } from '../../../../../constants/Map'
import { AmericanStatesActions } from '../../../../../store/AmericanStates'
import { CountyActions } from '../../../../../store/County'
import { MapActions } from '../../../../../store/Map'

export const handleClick = async (
  e: mapboxgl.MapMouseEvent,
  mapRef?: React.RefObject<mapboxgl.Map>,
  statesRef?: React.RefObject<any>,
  dispatch?: Dispatch,
) => {
  // Add check for marker clicks
  // NOT CALLED WHEN CLICKING ON PINS
/*  console.log(e.originalEvent.target instanceof HTMLElement, (e.originalEvent.target as HTMLElement).closest('.mapboxgl-marker') )
  if (e.originalEvent.target instanceof HTMLElement && 
      e.originalEvent.target.closest('.mapboxgl-marker')) {
    return;
  }*/
  
  const map = mapRef?.current;
  if (!map) return;
  const zoom = map.getZoom();
    
  if (!e.features?.length || !mapRef?.current || !dispatch) {
    return null
  }

  const stateOrCountyName = e.features[0].properties?.name

  if (!stateOrCountyName) {
    return
  }
  // BAD MATCH :Washington county will send user to washington state
  const isStateLevel = Boolean(statesRef?.current?.find((state) => state.state === stateOrCountyName)) && zoom <= ZOOM_LEVELS.STATE.MAX

  if(isStateLevel) {
    const { epaRegion, code } = stateToRegionByName[stateOrCountyName] || {}
  if (!epaRegion || !code) {
    console.warn(`No region data found for state: ${stateOrCountyName}`)
    return
  }

  const selectedState = statesRef?.current?.find((state) => state.state_abbr === code)

  if (!selectedState) return

  dispatch(AmericanStatesActions.setSelectedState(selectedState))

  if (selectedState.location) {
    const [lat, lng] = selectedState.location
    const zoom = selectedState.default_zoom

    dispatch(MapActions.setMapCenter({ lat, lng }))
    dispatch(MapActions.setMapZoom({zoom}))
    dispatch(CountyActions.setSelectedCounty(''))
  }
  }else if(!isStateLevel) {
    dispatch(CountyActions.setSelectedCounty(stateOrCountyName))
    
    // Get the geometry of the clicked feature
    const feature = e.features[0];
    if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon') {
      const bounds = new mapboxgl.LngLatBounds();
      const coordinates = feature.geometry.type === 'Polygon' 
        ? feature.geometry.coordinates[0] 
        : feature.geometry.coordinates[0][0];
      
      coordinates.forEach((coord) => {
        bounds.extend([coord[0], coord[1]]);
      });

      const center = bounds.getCenter();

      mapRef.current?.flyTo({
        center: [center.lng, center.lat],
        zoom: COUNTY_ZOOM_LEVEL,
      });
      
      // Zoom into the county
      dispatch(MapActions.setMapCenter({ lat: center.lat, lng: center.lng }))
      dispatch(MapActions.setMapZoom({zoom:COUNTY_ZOOM_LEVEL}))
    }
  }
}
